/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type AccountBillStatus =
  (typeof AccountBillStatus)[keyof typeof AccountBillStatus]

export const AccountBillStatus = {
  ACCEPTANCE_PENDING: "ACCEPTANCE_PENDING",
  ACCEPTED: "ACCEPTED",
  DRAFT: "DRAFT",
} as const
